import { fromJS } from 'immutable'

const initialState = fromJS({
    formid: '',
    formName: '',
    initialDate: '',
    finalDate: '',
    fieldToGraph: undefined,
    fieldToGraphName: undefined,
    chartSeries: [],
    chartList: []
})

const appreports = (state = initialState, action) => {
    switch (action.type) {
        case "SET_FILTERS":
            return state.merge({
                formid: action.payload.formid,
                initialDate: action.payload.initialDate,
                finalDate: action.payload.finalDate,
                formName: action.payload.formName,
                type: action.payload.type,
                responseSection: action.payload.responseSection
            })
        case "CLEAR_FILTERS":
            return state.merge({
                formid: '',
                initialDate: '',
                finalDate: '',
            })
        case "SET_FIELD_TO_GRAPH":
            return state.merge({
                fieldToGraph: action.payload.fieldToGraph,
                fieldToGraphName: action.payload.fieldToGraphName
            })
        case "SET_SERIES_GRAPH":
            return state.merge({
                chartSeries: action.payload.chartSeries,
                chartList: action.payload.chartList
            })
        case "CLEAR_FIELD_TO_GRAPH":
            return state.merge({
                fieldToGraph: undefined
            })
        default:
            return state
    }
}

export default appreports